import { required } from 'vuelidate/lib/validators'
import User from '@/models/User'
import Company from '@/models/Company'

export default {
    fields: {
        company_id: {
            label: 'Company',
            type: 'typeahead',
            options: [],
            async loadOptions (model) {
                Company.loadCompanyOptions(this)
            },
            validations: { required }
        },
        user_id: {
            label: 'User',
            type: 'typeahead',
            options: [],
            async loadOptions (model) {
                User.loadUserOptions(this)
            },
            validations: { required }
        },
        is_company_admin: {
            label: 'Is Company Admin',
            type: 'check',
        },
        //  other fields
        user_full_name: {
            label: 'User Name',
            type: 'text'
        },
        company_name: {
            label: 'Company Name',
            type: 'text'
        },
    }
}
